import { useRef } from "react";
import { usePendingOrders } from "./PendingOrdersContext";
import "./pendingOrderBadge.css";

export default function PendingOrderBadge({ className = "" }) {
  const { count, updateId } = usePendingOrders();
  const initialUpdateId = useRef(updateId);

  return (
    <span
      key={updateId}
      className={`pending-order-badge ${updateId !== initialUpdateId.current ? "pending-order-badge--updated" : ""} ${className}`}
      aria-label={`${count} سفارش در انتظار`}
    >
      {count.toLocaleString("fa-IR")}
    </span>
  );
}
